import React, { createContext, useContext, useState } from 'react';

/**
 * Global kontekst for «aktiv undermodul».
 *
 * Topp-nivå modul-id (?module=) styres av WarehouseMain. Mange moduler har i tillegg
 * interne undervisninger (f.eks. administrasjon → System Logger / application-logs) som
 * den globale ModuleIndicator ellers ikke kjenner til. En modul setter `subModuleId`
 * når en undervisning åpnes, og nullstiller den (null) ved retur til landingssiden /
 * ved unmount. ModuleIndicator leser verdien og viser/kopierer den.
 *
 * Generisk: virker for hele systemet, ikke bare administrasjon.
 */
interface SubModuleContextValue {
  subModuleId: string | null;
  setSubModuleId: (id: string | null) => void;
}

const SubModuleContext = createContext<SubModuleContextValue | undefined>(undefined);

export const SubModuleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [subModuleId, setSubModuleId] = useState<string | null>(null);
  return (
    <SubModuleContext.Provider value={{ subModuleId, setSubModuleId }}>
      {children}
    </SubModuleContext.Provider>
  );
};

/**
 * Robust uten provider: returnerer en no-op slik at en modul som rendres utenfor
 * WarehouseMain (f.eks. i en test) ikke krasjer.
 */
export const useSubModule = (): SubModuleContextValue => {
  const ctx = useContext(SubModuleContext);
  if (!ctx) {
    return { subModuleId: null, setSubModuleId: () => {} };
  }
  return ctx;
};
